var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
    backgroundImage: `url(${_vm.pinImageFiles[_vm.pinIndex]})`
  }),on:{"click":function($event){return _vm.$emit('pin-selected')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }